export function slugifyAgentName(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
}

export function buildAgentPath(agent = {}) {
  const id = agent.Id || agent.id
  const slug = slugifyAgentName(agent.Nombre)
  return `/agentes/${id}${slug ? `/${slug}` : ""}`
}
